module.exports = __webpack_public_path__ + "img/f.2c7b6926.jpg";